import { forceFlush } from './telemetrySdk';

// Registers event listeners that flush telemetry when the page is hidden or
// unloading. Core Web Vitals (INP, CLS) finalize only on pagehide /
// visibilitychange→hidden, so a periodic 60-second export won't capture the
// final values; we must forceFlush at that point. The listeners must be
// registered AFTER web-vitals' own visibility listeners so that recorded
// values are committed before we flush.

/**
 * Registers `pagehide` (window) and `visibilitychange→hidden` (document)
 * listeners that call `flush`. Returns an unregister function that removes
 * both listeners.
 *
 * The default `flush` calls {@link forceFlush} from the telemetry SDK, which
 * is a safe no-op before the SDK is initialized. Tests may supply a spy.
 */
export function registerUnloadFlush(flush: () => void = () => forceFlush()): () => void {
  const onPageHide = () => flush();
  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      flush();
    }
  };

  window.addEventListener('pagehide', onPageHide);
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    window.removeEventListener('pagehide', onPageHide);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
}
